import { render } from "./AuthCard.vue?vue&type=template&id=4c4da2e3&scoped=true&ts=true"
import script from "./AuthCard.vue?vue&type=script&lang=ts"
export * from "./AuthCard.vue?vue&type=script&lang=ts"

import "./AuthCard.vue?vue&type=style&index=0&id=4c4da2e3&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c4da2e3"]])

export default __exports__